/**
*
* ManageZaggleCard
*
*/

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import { Redirect, Link } from 'react-router-dom';
import endPoints from '../../config/endPoints';
import { AppWrappperHOC } from '../Root/HOC';
import Container from '../../components/Container';
import { selectLoggedIn, getDefaultError, isLoading } from '../HeaderContainer/selectors';
import { constants } from '../../devUtils';
import LoginPage from '../LoginPage';
import Loader from '../../components/Loader';
import Breadcrumb from '../../components/Breadcrumb';
import { LINK_ANDROID_APP, LINK_IOS_APP } from '../HeaderContainer/constants';
import { HelmetWrapper, SubTitle } from '../../components';

const Works = styled.div`
  background:${(props) => props.theme.lightWhite};
  padding:50px 100px;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    padding:20px;
  };
  h2{
    font-size:17px;
    color: ${(props) => props.theme.secoundaryColor};
    text-align:center;
    margin-bottom:25px;
  }
  ul{
    list-style:none;
    margin:0px;
    padding:0px;
    li{
      display: inline-block;
      width:33%;
      text-align:center;
      font-size:13px;
      position: relative;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        width:100%;
        display: inline-block;
      };
      &:nth-child(2){
        &:before{
          content: "";
          width: 117px;
          border: ${(props) => props.theme.secondaryColor} dotted 1px;
          position: absolute;
          top: 25%;
          left: -66px;
          @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
            display:none;
          };
        }
        &:after{
          content: "";
          width: 117px;
          border: ${(props) => props.theme.secondaryColor} dotted 1px;
          position: absolute;
          top: 25%;
          right: -66px;
          @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
            display:none;
          };
        }
      }
      img{
        width:95px;
        height:95px;
        border-radius:50%;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          float: left;
          display: block;
          margin-right: 20px;
        };
      }
      strong{
        display:block;
        margin-top:10px;
        font-weight:700;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          float: left;
          display: block;
        };
      }
      p{
        line-height:20px;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          float: left;
          display: block;
          width: 60%;
          text-align: left;
        };
      }
    }
  }
`;

const ImageSize = styled.div`
background: ${(props) => props.theme.whiteColor}; /* Old browsers */
background: -moz-linear-gradient(top, #ffffff 0%, #d0d0d0 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(top, #ffffff 0%,#d0d0d0 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to bottom, #ffffff 0%,#d0d0d0 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#d0d0d0',GradientType=0 ); /* IE6-9 */
height:530px;
text-align:center;
@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          height:auto;
        };
img{
  height:100%;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          height:auto;
          width:100%;
        };
}
`;

const CardsLanding = styled.section`
margin-top:50px;
.card-text{
  position:relative;
  min-height: 450px;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    min-height: 250px;
    };
}
.download{
  position: absolute;
    bottom: 0;
    right: 0;
    width: 55%;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      top: 60%;
    };
  p{

  }
  a{
    display: inline-block;
    background: #262423;
    width: 45%;
    border-radius: 10px;
    padding: 10px 0px;
    margin-right: 10px;
    img{
      width: 100%;
    border-radius: 10px;
    }
  }
}
.card-img{
  position: absolute;
    width: 61%;
    left: -10%;
    top: 27%;
    filter: grayscale(100%);
}
.works{
  box-shadow: 0px 3px 16px #0000000A;
    border-radius: 50%;
    width: 350px;
    display: inline-block;
    height: 350px;
    position: relative;
    text-align: left;
    padding-left: 8%;
    padding-top: 45px;
    vertical-align: bottom;
    img{
      display:block;
      width: 35%;
    margin-bottom: 20px;
    }
    h2{
      position:absolute;
      left:0px;
      font-size: 36px;
    }
    strong{
      color: ${(props) => props.theme.primaryColor};
      margin-bottom: 20px;
      display: block;
    }
    p{
      font-size:14px;
      color: ${(props) => props.theme.blackColor};
      width: 90%;
    }
}
`;

const LoginCard = styled.div`
padding: 30px;
.note{
  width: 87%;
    margin: 0 auto;
    margin-top:20px;
}
`;

class ManageZaggleCard extends PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isLoggedIn, apiResonse, isLoadingStatus, history, location } = this.props;
    if (isLoggedIn) {
      return <Redirect to={constants.LINK_PAY_BALANCE} />;
    } else if (isLoadingStatus) {
      return <Loader />;
    }
    return (
      <Fragment>
        <HelmetWrapper location={location} />
        <Breadcrumb />
        <CardsLanding>
          <img src={endPoints.LOGIN_CARD.URL} alt={endPoints.LOGIN_CARD.ALT} className="card-img" />
          <Container>
            <Row align="stretch" type="flex" gutter={24} >
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="card-text">
                <h1 className="font-30">Choose the perfect card</h1>
                <div className="download">
                  <p>A one-stop gifting solution for your employees and channel partners. It gives limitless choices to your employees for their customized wants.</p>
                  <Link to={LINK_ANDROID_APP} target="_blank">
                    <img src={endPoints.ZAGGLE_PLAY_STORE.URL} alt={endPoints.ZAGGLE_PLAY_STORE.ALT} />
                  </Link>
                  <Link to={LINK_IOS_APP} target="_blank">
                    <img src={endPoints.ZAGGLE_APP_STORE.URL} alt={endPoints.ZAGGLE_APP_STORE.ALT} />
                  </Link>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <LoginCard>
                  <LoginPage apiResonse={apiResonse} isLoaderRequired history={history} />
                  <div className="note">Continue to access all your card details, check balance and <br />view all card transactions</div>
                </LoginCard>
              </Col>
            </Row>
            <div className="text-center margin-t-100">
              <SubTitle fontWeight="900">How it Works ?</SubTitle>
            </div>
            <div className="works margin-r-3 margin-b-5">
              <h2>01</h2>
              <img src={endPoints.HIW_SIGNUP.URL} alt={endPoints.HIW_SIGNUP.ALT} />
              <strong>Sign Up</strong>
              <p>Sign Up, it&apos;s easy and fast.Already have an account? Simply Login  </p>
            </div>
            <div className="works margin-r-3 margin-b-5">
              <h2>02</h2>
              <img src={endPoints.HTW_ADDCARD.URL} alt={endPoints.HTW_ADDCARD.ALT} />
              <strong>Add Card</strong>
              <p>Enter Card Number.<br /> Verify OTP.<br />&nbsp;</p>
            </div>
            <div className="works margin-b-5">
              <h2>03</h2>
              <img src={endPoints.HIW_TRANSACTIONS.URL} alt={endPoints.HIW_TRANSACTIONS.ALT} />
              <strong>View Transactions</strong>
              <p>Access all your Card details.Check Balance, View Transactions,Block Card and more.</p>
            </div>
          </Container>
        </CardsLanding>
      </Fragment>
    );
  }
}

ManageZaggleCard.propTypes = {
  isLoggedIn: PropTypes.bool,
  apiResonse: PropTypes.object,
  isLoadingStatus: PropTypes.bool,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

ManageZaggleCard.defaultProps = {
  isLoggedIn: false,
  apiResonse: {},
  isLoadingStatus: false,
};


const mapDispatchToProps = (dispatch) => ({ // eslint-disable-line 
  // onChangeSignUpForm: (prop, value) => dispatch(changeSignUpForm(prop, value)),
});

const mapStateToProps = createStructuredSelector({
  isLoggedIn: selectLoggedIn(),
  apiResonse: getDefaultError(),
  isLoadingStatus: isLoading(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(ManageZaggleCard));
export default component;



// WEBPACK FOOTER //
// client/containers/ManageZaggleCard/ManageZaggleCardsLogin.js